import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './award-summary-section.styl'

class AwardSummarySection extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any
  }

  render() {
    return (
      <div className={[this.props.className, styles.section].join(' ')}>
        {this.props.children}
      </div>
    )
  }
}

export default AwardSummarySection
